import React from 'react';
import { Button } from 'antd';

// Aviso que cobre o vídeo enquanto a chamada não está de pé.
function StageOverlay({ overlay, onRetry }) {
  if (!overlay) {
    return null;
  }
  return (
    <div className="tmd-overlay">
      <span className="tmd-overlay-title">{overlay.title}</span>
      {overlay.text ? <span className="tmd-overlay-text">{overlay.text}</span> : null}
      {overlay.action === 'retry' ? (
        <Button type="primary" onClick={onRetry}>Tentar novamente</Button>
      ) : null}
    </div>
  );
}

export default StageOverlay;
